import { render, staticRenderFns } from "./CalcEstadoDatos.vue?vue&type=template&id=06dc5de2"
import script from "./CalcEstadoDatos.vue?vue&type=script&lang=js"
export * from "./CalcEstadoDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports